export default {
  'login.userName': '用户名',
  'login.password': '密码',
  'login.message-invalid-credentials': '账户或密码错误',
  'login.remember-me': '自动登录',
  'login.login': '登录',
  'validation.userName.required': '请输入用户名!',
  'validation.password.required': '请输入密码！',
};
